<div class="pb-5 sopSelectContain">
    <h3 class="section-title">
        {{ 'SOP_OBSERVATION.SELECT.SOP' | translate }}
    </h3>

    <div class="row justify-content-md-start justify-content-center">
        <div class="col-auto card-strip d-flex mpr-1" *ngFor="let sop of sopDetailList; let i = index">
            <div #sopList class="card-task" [ngClass]="(activeClass[i])?'active':''" (click)="selectSop(i)">
                <div class="card-task-media">
                    <img [ngClass]="(sop.sopImage)?'svg':'no-image'" [src]="(sop.sopImage)?layoutService.serverUrl+sop.sopImage:'assets/img/fallback-img.png'" (error)="errImg($event)">
                </div>
                <div class="d-flex card-task-content">
                    <input id="radiosop_{{i}}" class="card-task-radio" type="radio" [value]="i" name="sops" [(ngModel)]="radioSelected">
                    <div class="d-grid">
                        <div class="card-task-title">{{getSOPTitle(sop.latestTitle) | labelSanitizer}}</div>
                        <span class="card-task-desc">{{getSOPDescription(sop.description) | labelSanitizer}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row justify-content-center">
    <div class="col-12 sopSelectFooter d-flex justify-content-end" >
        <button class="btn-bd-empty mr-3" (click)="backToNewObserve()">{{ 'SOP_OBSERVATION.BACK' | translate }}</button>
        <button class="btn-bd" (click)="openSopDetails()" [disabled]='disableStartObservation()'>{{ 'SOP_OBSERVATION.CONTINUE' | translate }}</button>
    </div>
</div>

<!-- Modal - Add User Confirmation -->
<ng-template #template>
    <div class="p-0 modal-header justify-content-between align-items-center">
        <h5 class="mt-4 mb-3 font-weight-bold">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="" >
        <p class="">{{ 'SOP_OBSERVATION.SUCCESSFULLY_ADDED_SOP_OBSERVATION' | translate }}</p>
    </div>
    <div class="modal-footer">
        <div class="p-0 container-fluid">
            <div class="justify-content-end align-items-end d-flex">
                <button (click)="modalRef.hide();closeModal()" class="btn-bd-empty">{{ translationKeys.InstitutionManagement.Close | translate }}</button>
            </div>
        </div>
    </div>
</ng-template>